// extracted by mini-css-extract-plugin
export default {"container":"StoreError_container__SzyGs","button":"StoreError_button__gIVbL","loading":"StoreError_loading__EeM1U"};